import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router } from '@angular/router';
import { PermisoService } from '@services/permiso/permiso.service';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { LoginService } from '@services/login/login.service';
import { UsuarioDto } from '@models/usuario/usuarioDto.model';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { PermisoDto } from '@models/seguridad/permisos/permisoDto.model';

@Component({
  selector: 'app-cargando-inicio-app',
  standalone: true,
  imports: [NgxSpinnerModule, CommonModule],
  styleUrl: './cargando-inicio-app.component.css',
  templateUrl: './cargando-inicio-app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CargandoInicioAppComponent {
  permisosDto!: PermisoDto[];
  user!: UsuarioDto;

  constructor(private router: Router,
    private spinner: NgxSpinnerService,
    private permisoService: PermisoService,
    private loginService: LoginService,
    private snackBar: SnackBarService,

  ) {

  }

  ngOnInit(): void {
    this.router.navigate(["/dashboard"])
  }


}
